import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchVenuePriceBandingData } from "../../services/priceBandingService/fetchPriceBandings";
import { isAgencyApproved, token } from "../../modules/auth";
import { connect, useSelector } from "react-redux";
import PriceBandingReduced from "../PriceBanding/PriceBandingReduced";
import { getFormValues } from "redux-form";
import ExclusionDatesWarning from "../../pages/admin/EditVenue/ConferencePricing/PriceBanding/ExclusionDatesWarning";
import { fetchOffersForVenue } from "../../services/venueService/offersService";
import Label from "../Search/Label";
import { isOfferVisible } from "../../utils";
import PreferredProgrammeBadge from "../PreferredProgrammes/PreferredProgrammeBadge";
import { checkVenueForPreferredProgramme } from "../../services/hotelGroupService/preferredProgrammesService";
import CommercialDealBadge from "../CommercialDeals/CommercialDealBadge";
import { checkVenuesForCommercialDeals } from "../../services/commercialDealService/commercialDeals";
import { ButtonBrand } from "../Button";

const mapDispatchToProps = {};

const mapStateToProps = state => ({
  isAgencyApproved: isAgencyApproved(state),
  token: token(state),
});

const VenueCard = ({
  venue,
  removeVenue,
  canRemove = false,
  newTab = false,
  token,
  isAgencyApproved,
  showDetailsOnHover
}) => {
  const values = useSelector(getFormValues("rfp_enquiry")) || {};
  let [venuePriceBandings, setVenuePriceBandings] = useState(false);
  let [isInProgramme, setIsInProgramme] = useState(false);
  let [hasCommercialDeal, setHasCommercialDeal] = useState(false);
  const [offers, setOffers] = useState([]);

  useEffect(() => {
    setOffers([]);
    setVenuePriceBandings(false);
    setIsInProgramme(false);
    setHasCommercialDeal(false);
    fetchOffersForVenue(venue.slug).then(response => {
      setOffers(response.result);
    });
    fetchVenuePriceBandingData(token, venue.slug).then(response => {
      if (response && Object.keys(response).length !== 0) {
        setVenuePriceBandings(response);
      }
    });
    checkVenueForPreferredProgramme(token).then(response => {
      setIsInProgramme(response);
    });
    checkVenuesForCommercialDeals([venue.id], token).then(response => {
      setHasCommercialDeal(response);
    });
  }, [venue.slug]);
  let address = venue.town;
  if (address && venue.county) {
    address += `, ${venue.county}`;
  } else if (venue.county) {
    address = venue.county;
  }
  const image =
    venue.image ||
    venue.featured_image_id ||
    (venue.images && venue.images[0]) ||
    {}.id;
  const bgImage = image
    ? `${window.API}/venues/${venue.slug}/images/${image}`
    : null;
  const offerCounts = offers?.reduce((acc, offer) => {
    if (isOfferVisible(offer)) {
      const typeName = offer.type;
      acc[typeName] = (acc[typeName] || 0) + 1;
    }
    return acc;
  }, {});
  return (
    <div
      key={venue.id}
      className="flex flex-wrap flex-col md:flex-row bg-white"
      style={{ cursor: "grab" }}
    >
      <div className="item h-48 md:w-1/2 flex-auto">
        {canRemove ? (
          <div className="block absolute mt-2 ml-2">
            <i
              onClick={() => removeVenue(venue.id)}
              className="fas text-2lg fa-minus-circle hover:text-red pointer"
              title="Remove venue from enquiry"
            />
          </div>
        ) : null}
        <div className="bg-blue-light h-full">
          {showDetailsOnHover ?
            <div
              className={`bg-cover bg-center bg-no-repeat  relative overflow-hidden`}
              style={{
                backgroundImage: `url(${bgImage})`,
                objectFit: "cover",
                height: "100%",
                width: "100%",
              }}

            >
              <div className="w-full h-full hidden lg:block absolute pin-t pin-b pin-l hover:bg-black-transparent transition image-with-details">
                <a rel="noopener noreferrer" href={`venue/${venue.slug}`} target="_blank">  <ButtonBrand
                  id="view-details-button"
                  small
                  style={{
                    transition: "opacity 0.2s ease-in-out",
                    padding: "10px",
                  }}
                  classes="absolute-center"
                >
                  View details
                </ButtonBrand></a>

              </div>
            </div>
            :

            <img
            src={`${bgImage}`}
            alt={venue.name}
            style={{
              objectFit: "cover",
              height: "100%",
              width: "100%",
            }}
          />}

        </div>
      </div>
      <div className="item p-3 flex h-24 md:h-48 md:w-1/2 flex-auto flex-col justify-between">
        <h3 className="uppercase font-bold text-lg">
          <Link
            to={`/venue/${venue.slug}`}
            className="text-black hover:text-brand"
            title="View profile"
            target={newTab ? "_blank" : undefined}
            rel={newTab ? "noopener noreferrer" : undefined}
          >
            {venue.name}
          </Link>
        </h3>
        <div className={"flex"}>
          <div className={"text-xs"}>
            {venuePriceBandings &&
            venuePriceBandings["show_24hr_on_profile"] &&
            venuePriceBandings["twenty_four_hr_price_banding_rate"] ? (
              <React.Fragment>
                <PriceBandingReduced
                  type={"24hr"}
                  venuePriceBindings={venuePriceBandings}
                />
                <br />
              </React.Fragment>
            ) : null}
            {venuePriceBandings &&
            !venuePriceBandings["show_24hr_on_profile"] &&
            venuePriceBandings["bb_price_banding_rate"] ? (
              <React.Fragment>
                <PriceBandingReduced
                  type={"bb"}
                  venuePriceBindings={venuePriceBandings}
                />
                <br />
              </React.Fragment>
            ) : null}
            {venuePriceBandings &&
            venuePriceBandings["ddr_price_banding_rate"] ? (
              <React.Fragment>
                <PriceBandingReduced
                  type={"ddr"}
                  venuePriceBindings={venuePriceBandings}
                />
                <br />
              </React.Fragment>
            ) : null}
          </div>
          <div className={"self-end"}>
            <ExclusionDatesWarning
              fromDate={values.date_from}
              toDate={values.date_to}
              venueSlug={venue.slug}
            />
          </div>
        </div>
        <div className="flex mt-2">
          {isAgencyApproved &&
            (offerCounts["commission-offers"] || 0) +
              (offerCounts["agency-rates"] || 0) >
              0 && (
              <div className="rounded-sm bg-dark-red py-1 px-2 uppercase text-white text-sm font-normal mr-2 mb-2">
                <span title="Agency offer(s)">
                  <span className="font-bold">
                    {(offerCounts["commission-offers"] || 0) +
                      (offerCounts["agency-rates"] || 0)}
                  </span>
                </span>
              </div>
            )}
          {offerCounts && offerCounts["special-offers"] > 0 && (
            <div className="rounded-sm bg-green py-1 px-2 uppercase text-white text-sm font-normal mr-2 mb-2 ">
              <Link
                className="text-white text-sm font-normal"
                to={`/venue/${venue.slug}#offers`}
              >
                <span title="Special offer(s)">
                  <span className="font-bold">
                    {offerCounts["special-offers"]}
                  </span>
                </span>
              </Link>
            </div>
          )}

          <PreferredProgrammeBadge
            venue={venue}
            isInProgramme={isInProgramme}
            text={"PP"}
            singleButton={true}
          />
          <CommercialDealBadge
            venue={venue}
            small={true}
            hasCommercialDeal={hasCommercialDeal}
          />
        </div>
        <p className="font-normal mb-0 text-sm">{address}</p>
      </div>

      {venue.capacity || venue.bedrooms || venue.meeting_rooms ? (
        <div className="item flex flex-row flex-auto font-normal text-lg py-2 justify-between">
          {venue.capacity ? (
            <div className="mx-2" title="Capacity">
              <i className="mr-2 fas fa-users" />
              {venue.capacity}
            </div>
          ) : null}
          {venue.bedrooms ? (
            <div className="mx-2" title="Bedrooms">
              <i className="mr-2 fas fa-bed" />
              {venue.bedrooms}
            </div>
          ) : null}
          {venue.meeting_rooms ? (
            <div className="mx-2" title="Meeting Rooms">
              <i className="mr-2 fas fa-handshake" />
              {venue.meeting_rooms}
            </div>
          ) : null}
        </div>
      ) : (
        <div className="item flex flex-row flex-auto font-normal text-lg bg-white justify-between p-2">
          Venue data not provided
        </div>
      )}
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(VenueCard);
